import { Device } from 'types';
import { DeviceMapFilters } from './DeviceMap';

export const isDeviceVisible = (
    device: Device,
    mapFilters: DeviceMapFilters
) => {
    const tankLevel = device.estimated_tank;

    if (!tankLevel) {
        return true;
    }

    switch (true) {
        case tankLevel >= 80 && !!mapFilters['v80']:
            return true;
        case tankLevel >= 60 && tankLevel < 80 && !!mapFilters['v60']:
            return true;
        case tankLevel >= 40 && tankLevel < 60 && !!mapFilters['v40']:
            return true;
        case tankLevel >= 20 && tankLevel < 40 && !!mapFilters['v20']:
            return true;
        case tankLevel < 20 && !!mapFilters['v0']:
            return true;
        default:
            return false;
    }
};
